export interface ConfiguratorBannerInfo {
    webLink: string;
    image: string;
    bannerTitle: string;
}

export const CONFIGURATOR_BANNER_MAP: Record<string, ConfiguratorBannerInfo> = {
    photovoltaic: {
        webLink: 'https://www.obo.de/de-de/branchenloesungen/energieversorgung/photovoltaik',
        image: 'assets/img/portal/crossSelling/photovoltaic_banner.jpg',
        bannerTitle: 'PORTAL_PHOTOVOLTAIC_BANNER_TITLE'
    }
    // to be extended for other configurators
};
